// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   Box,
// // //   Paper,
// // //   Table,
// // //   TableBody,
// // //   TableContainer,
// // //   TableHead,
// // //   TablePagination,
// // //   MenuItem,
// // //   Select,
// // //   FormControl,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   IconButton,
// // //   Button,
// // // } from '@mui/material';
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import PrintIcon from '@mui/icons-material/Print';
// // // import styles from '../../../styles.module.css';
// // // import {
// // //   Breadcrumb,
// // //   StyledTableCell,
// // //   StyledTableRow,
// // // } from '../../reusableComponent/Reusables';
// // // import HeaderSection from '../../reusableComponent/HeaderSection';
// // // import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// // // import customer_holding_reportService from '../../../services/report/customer_holding_report.Service';

// // // const CustomerHoldingReport = () => {
// // //   const [searchKey, setSearchKey] = useState('');
// // //   const [rows, setRows] = useState([]);
// // //   const [total_count, setTotalCount] = useState(null);
// // //   const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
// // //   const [successMessage, setSuccessMessage] = useState(null);
// // //   const [customers, setCustomers] = useState([]);
// // //   const [selectedCustomer, setSelectedCustomer] = useState('');
// // //   const [openDetail, setOpenDetail] = useState(false);
// // //   const [dialogData, setDialogData] = useState([]);
// // //   const [dialogTitle, setDialogTitle] = useState('');
// // //   const [depot, setDepot] = useState([]);
// // //   const today = new Date();
// // //   const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(
// // //     today.getMonth() + 1
// // //   ).padStart(2, '0')}/${today.getFullYear()}`;

// // //   useEffect(() => {
// // //     setTotalCount(rows[0]?.totalCount);
// // //   }, [rows]);

// // //   useEffect(() => {
// // //     fetchData();
// // //   }, [searchKey, selectedCustomer, controller.page, controller.rowsPerPage]);

// // //   const fetchData = async () => {
// // //     try {
// // //       const params = {
// // //         page: controller.page + 1,
// // //         size: controller.rowsPerPage,
// // //         searchKey,
// // //       };
// // //       const response = await customer_holding_reportService.getCylinderholdingreportlist(params);

// // //       if (Array.isArray(response)) {
// // //         let filteredRows = response;

// // //         if (selectedCustomer) {
// // //           filteredRows = filteredRows.filter(
// // //             (row) => row.customer_name === selectedCustomer
// // //           );
// // //         }

// // //         setRows(filteredRows);
// // //         const uniqueCustomers = [...new Set(response.map((item) => item.customer_name))];
// // //         setCustomers(uniqueCustomers);
// // //       } else {
// // //         setRows([]);
// // //         setCustomers([]);
// // //         setSuccessMessage('No data received from the server');
// // //       }
// // //     } catch (error) {
// // //       console.error('Error fetching data:', error);
// // //       setSuccessMessage('Error fetching data');
// // //       setRows([]);
// // //       setCustomers([]);
// // //     }
// // //   };

// // //   const handleChangePage = (event, newPage) => {
// // //     setController((prev) => ({ ...prev, page: newPage }));
// // //   };

// // //   const handleChangeRowsPerPage = (event) => {
// // //     setController({
// // //       page: 0,
// // //       rowsPerPage: parseInt(event.target.value, 10),
// // //     });
// // //   };

// // //   const handleSearch = (e) => {
// // //     setSearchKey(e.target.value);
// // //     setController((prev) => ({ ...prev, page: 0 }));
// // //   };

// // //   const handleCustomerChange = (event) => {
// // //     setSelectedCustomer(event.target.value);
// // //     setController((prev) => ({ ...prev, page: 0 }));
// // //   };

// // //   const handleOpenDialog = (row) => {
// // //     setDialogData(row.cylinders || []);
// // //     setDialogTitle(`Cylinder Details for ${row.customer_name} (${row.product_code}) - ${formattedDate}`);
// // //     setOpenDetail(true);
// // //   };

// // //   const handleClose = () => {
// // //     setOpenDetail(false);
// // //     setDialogData([]);
// // //     setDialogTitle('');
// // //   };

// // //   const dateConversion = (date) => {
// // //     if (!date) return '';
// // //     const today = new Date(date);
// // //     const dd = String(today.getDate()).padStart(2, '0');
// // //     const mm = String(today.getMonth() + 1).padStart(2, '0');
// // //     const yyyy = today.getFullYear();
// // //     return `${dd}/${mm}/${yyyy}`;
// // //   };

// // //   const handlePrint = (isDialog = false, dialogTitle = '') => {
// // //     const printContentId = isDialog ? 'printable-dialog-table' : 'printable-main-table';
// // //     const printContent = document.getElementById(printContentId)?.outerHTML || '';

// // //     if (!printContent) {
// // //       setSuccessMessage('Error: No content available to print');
// // //       return;
// // //     }

// // //     const printWindow = window.open('', '_blank');
// // //     if (!printWindow) {
// // //       setSuccessMessage('Error: Unable to open print window. Please check pop-up blocker settings.');
// // //       return;
// // //     }

// // //     const tableStyles = `
// // //       <style>
// // //         body { 
// // //           font-family: Arial, sans-serif; 
// // //           margin: 20px; 
// // //         }
// // //         table { 
// // //           width: 100%; 
// // //           border-collapse: collapse; 
// // //         }
// // //         th, td { 
// // //           border: 1px solid #ddd; 
// // //           padding: 8px; 
// // //           text-align: left; 
// // //           font-size: 14px; 
// // //         }
// // //         th { 
// // //           background-color: #f2f2f2; 
// // //           font-weight: bold; 
// // //         }
// // //         tr:nth-child(even) { 
// // //           background-color: #f9f9f9; 
// // //         }
// // //         .inspection_cell:hover { 
// // //           background-color: #f5f5f5; 
// // //           cursor: pointer; 
// // //         }
// // //         @media print { 
// // //           .no-print { display: none; } 
// // //         }
// // //       </style>
// // //     `;

// // //     printWindow.document.write(`
// // //       <html>
// // //         <head>
// // //           <title>Customer Holding Report${isDialog ? ' - Cylinder Details' : ''}</title>
// // //           ${tableStyles}
// // //         </head>
// // //         <body>
// // //           <h3>${isDialog ? dialogTitle : 'Customer Holding Report'}</h3
// // //           >
// // //           ${printContent}
// // //         </body>
// // //       </html>
// // //     `);

// // //     printWindow.document.close();
// // //     printWindow.onload = () => {
// // //       printWindow.focus();
// // //       printWindow.print();
// // //       printWindow.onafterprint = () => printWindow.close();
// // //       setTimeout(() => printWindow.close(), 0);
// // //     };
// // //   };

// // //   const start = controller.page * controller.rowsPerPage;
// // //   const end = start + controller.rowsPerPage;
// // //   const paginatedRows = rows.slice(start, end);
// // //   const paginationInfo = `${start + 1}-${Math.min(end, rows.length)} of ${rows.length}`;

// // //   return (
// // //     <Box className={styles.cts_page} sx={{ padding: '0px', margin: '0px' }}>
// // //       <Box className={styles.body}>
// // //         <Breadcrumb routeSegments={[{ name: 'Customer Holding Report' }]} />

// // //         <HeaderSection
// // //           title="CUSTOMER HOLDING REPORT"
// // //           searchKey={searchKey}
// // //           handleSearch={handleSearch}
// // //           sortedRows={rows}
// // //           fields={[]}
// // //           labels={[]}
// // //           filename="Customer_Holding_Report"
// // //           paginationInfo={paginationInfo}
// // //           controller={controller}
// // //           handleChangePage={handleChangePage}
// // //           showAddButton={false}
// // //         />

// // //         <Box sx={{ mb: 2, ml: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
// // //           <FormControl sx={{ minWidth: 200 }}>
// // //             <Select
// // //               value={selectedCustomer}
// // //               onChange={handleCustomerChange}
// // //               displayEmpty
// // //             >
// // //               <MenuItem value="">All Customers</MenuItem>
// // //               {customers.map((customer, idx) => (
// // //                 <MenuItem key={idx} value={customer}>
// // //                   {customer}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>
// // //           <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
// // //             <Button
// // //               variant="contained"
// // //               startIcon={<PrintIcon />}
// // //               onClick={() => handlePrint(false)}
// // //               className="no-print"
// // //             >
// // //               Print
// // //             </Button>
// // //           </Box>
// // //         </Box>

// // //         <Paper sx={{ width: '100%' }}>
// // //           <TableContainer component={Paper} className={styles.list_tbl_container} id="printable-main-table">
// // //             <Table size="small" stickyHeader>
// // //               <TableHead>
// // //                 <StyledTableRow>
// // //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// // //                     Sr No
// // //                   </StyledTableCell>
// // //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// // //                     Customer Name
// // //                   </StyledTableCell>
// // //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// // //                     Product Code
// // //                   </StyledTableCell>
// // //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// // //                     Total No Of Cylinder
// // //                   </StyledTableCell>
// // //                 </StyledTableRow>
// // //               </TableHead>
// // //               <TableBody>
// // //                 {paginatedRows.length > 0 ? (
// // //                   paginatedRows.map((row, index) => (
// // //                     <StyledTableRow key={index}>
// // //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                         {index + 1}
// // //                       </StyledTableCell>
// // //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                         {row.customer_name}
// // //                       </StyledTableCell>
// // //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                         {row.product_code}
// // //                       </StyledTableCell>
// // //                       <StyledTableCell
// // //                         align="left"
// // //                         className={styles.inspection_cell}
// // //                         onClick={() => handleOpenDialog(row)}
// // //                         style={{ cursor: 'pointer', color: '#1976d2' }}
// // //                       >
// // //                         {row.total_cylinders}
// // //                       </StyledTableCell>
// // //                     </StyledTableRow>
// // //                   ))
// // //                 ) : (
// // //                   <StyledTableRow>
// // //                     <StyledTableCell colSpan={3} align="center">
// // //                       No records found
// // //                     </StyledTableCell>
// // //                   </StyledTableRow>
// // //                 )}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>

// // //           <TablePagination
// // //             component="div"
// // //             count={rows.length}
// // //             page={controller.page}
// // //             onPageChange={handleChangePage}
// // //             rowsPerPage={controller.rowsPerPage}
// // //             onRowsPerPageChange={handleChangeRowsPerPage}
// // //             className="no-print"
// // //           />
// // //         </Paper>

// // //         <Dialog
// // //           PaperProps={{
// // //             sx: {
// // //               minWidth: '90%',
// // //               maxHeight: '90%',
// // //             },
// // //           }}
// // //           onClose={handleClose}
// // //           open={openDetail}
// // //         >
// // //           <DialogTitle id="customized-dialog-title">
// // //             {dialogTitle}
// // //             <IconButton
// // //               aria-label="close"
// // //               onClick={handleClose}
// // //               sx={{
// // //                 position: 'absolute',
// // //                 right: 8,
// // //                 top: 8,
// // //               }}
// // //             >
// // //               <CloseIcon />
// // //             </IconButton>
// // //           </DialogTitle>
// // //           <DialogContent dividers>
// // //             <Box sx={{ display: 'flex', justifyContent: 'flex-end' ,paddingBottom:'20px' }}>
// // //               <Button
// // //                 variant="contained"
// // //                 startIcon={<PrintIcon />}
// // //                 onClick={() => handlePrint(true, dialogTitle)}
// // //                 className="no-print"
// // //               >
// // //                 Print
// // //               </Button>
// // //             </Box>
// // //             <TableContainer
// // //               component={Paper}
// // //               className={`${styles.list_tbl_container} printable-table`}
// // //               id="printable-dialog-table"
// // //             >
// // //               <Table size="small" stickyHeader className="printable-table">
// // //                 <TableHead className={styles.table_head_container}>
// // //                   <StyledTableRow>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Sr No</StyledTableCell>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Cylinder No</StyledTableCell>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Tag No</StyledTableCell>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Owner</StyledTableCell>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>DC_NO</StyledTableCell>
// // //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>DC_Date</StyledTableCell>
// // //                   </StyledTableRow>
// // //                 </TableHead>
// // //                 <TableBody sx={{ backgroundColor: '#fff' }}>
// // //                   {dialogData.length > 0 ? (
// // //                     dialogData.map((row, index) => (
// // //                       <StyledTableRow key={index}>
// // //                         <StyledTableCell align="left">{index + 1}</StyledTableCell>
// // //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                           {row.cylinder_no || '-'}
// // //                         </StyledTableCell>
// // //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                           {row.tag_no || '-'}
// // //                         </StyledTableCell>
// // //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                           {row.owner || '-'}
// // //                         </StyledTableCell>
// // //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                           {row.dc_no || '-'}
// // //                         </StyledTableCell>
// // //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// // //                           {dateConversion(row.dc_date || '-')}
// // //                         </StyledTableCell>
// // //                       </StyledTableRow>
// // //                     ))
// // //                   ) : (
// // //                     <StyledTableRow>
// // //                       <StyledTableCell colSpan={4} align="center">
// // //                         No cylinder details available
// // //                       </StyledTableCell>
// // //                     </StyledTableRow>
// // //                   )}
// // //                 </TableBody>
// // //               </Table>
// // //             </TableContainer>
// // //           </DialogContent>
// // //         </Dialog>

// // //         <ReusableSnackbar
// // //           open={!!successMessage}
// // //           onClose={(event, reason) => {
// // //             if (reason !== 'clickaway') {
// // //               setSuccessMessage(null);
// // //             }
// // //           }}
// // //           message={successMessage}
// // //           autoHideDuration={2000}
// // //           vertical="top"
// // //           horizontal="right"
// // //         />
// // //       </Box>
// // //     </Box>
// // //   );
// // // };

// // // export default CustomerHoldingReport;

// // import React, { useState, useEffect } from 'react';
// // import {
// //   Box,
// //   Paper,
// //   Table,
// //   TableBody,
// //   TableContainer,
// //   TableHead,
// //   TablePagination,
// //   MenuItem,
// //   Select,
// //   FormControl,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   IconButton,
// //   Button,
// //   Typography,
// // } from '@mui/material';
// // import CloseIcon from '@mui/icons-material/Close';
// // import PrintIcon from '@mui/icons-material/Print';
// // import styles from '../../../styles.module.css';
// // import {
// //   Breadcrumb,
// //   StyledTableCell,
// //   StyledTableRow,
// // } from '../../reusableComponent/Reusables';
// // import HeaderSection from '../../reusableComponent/HeaderSection';
// // import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';
// // import customer_holding_reportService from '../../../services/report/customer_holding_report.Service';
// // import customermaster from '../../../services/masters/customerMaster.Service';
// // import Autocomplete from '@mui/material/Autocomplete';
// // import TextField from '@mui/material/TextField';

// // const CustomerHoldingReport = () => {
// //   const [searchKey, setSearchKey] = useState('');
// //   const [rows, setRows] = useState([]);
// //   const [total_count, setTotalCount] = useState(null);
// //   const [controller, setController] = useState({ page: 0, rowsPerPage: 10 });
// //   const [successMessage, setSuccessMessage] = useState(null);
// //   const [customers, setCustomers] = useState([]);
// //   const [selectedCustomer, setSelectedCustomer] = useState('');
// //   const [openDetail, setOpenDetail] = useState(false);
// //   const [dialogData, setDialogData] = useState([]);
// //   const [dialogTitle, setDialogTitle] = useState('');
// //   const [depot, setDepot] = useState([]);
// //   const [customerSearch, setCustomerSearch] = useState('');
// //   const today = new Date();
// //   const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(
// //     today.getMonth() + 1
// //   ).padStart(2, '0')}/${today.getFullYear()}`;

// //   useEffect(() => {
// //     setTotalCount(rows[0]?.totalCount);
// //   }, [rows]);

// //   useEffect(() => {
// //   fetchData();
// // }, [searchKey, controller.page, controller.rowsPerPage]);
// //   useEffect(() => {
// // const fetchAllCustomers = async () => {
// //   try {
// //     const response = await customermaster.getCustomerList({ 
// //       page: 0, size: 999, searchKey: '' 
// //     });
// //     const uniqueCustomers = (response || []).map(c => ({ 
// //       id: c.cust_id, 
// //       name: c.cust_name 
// //     }));
// //     setCustomers(uniqueCustomers);
// //   } catch (error) {
// //     console.error('Error fetching customers:', error);
// //   }
// // };
// //   fetchAllCustomers();
// // }, []);

// //   // const fetchData = async () => {
// //   //   try {
// //   //     const params = {
// //   //       page: controller.page + 1,
// //   //       size: controller.rowsPerPage,
// //   //       searchKey,
// //   //     };
// //   //     const response = await customer_holding_reportService.getCylinderholdingreportlist(params);

// //   //     if (Array.isArray(response)) {
// //   //       let filteredRows = response;

// //   //       if (selectedCustomer) {
// //   //         filteredRows = filteredRows.filter(
// //   //           (row) => row.customer_name === selectedCustomer
// //   //         );
// //   //       }

// //   //       setRows(filteredRows);
// //   //       const uniqueCustomers = [...new Set(response.map((item) => item.customer_name))];
// //   //       setCustomers(uniqueCustomers);
// //   //     } else {
// //   //       setRows([]);
// //   //       setCustomers([]);
// //   //       setSuccessMessage('No data received from the server');
// //   //     }
// //   //   } catch (error) {
// //   //     console.error('Error fetching data:', error);
// //   //     setSuccessMessage('Error fetching data');
// //   //     setRows([]);
// //   //     setCustomers([]);
// //   //   }
// //   // };

// // const fetchData = async () => {
// //   try {
// //     const params = {
// //       page: controller.page + 1,
// //       size: controller.rowsPerPage,
// //       searchKey,
// //     };
// //     const response = await customer_holding_reportService.getCylinderholdingreportlist(params);

// //     if (Array.isArray(response)) {
// //       let filteredRows = response;

// //       if (selectedCustomer) {
// //         filteredRows = filteredRows.filter(
// //           (row) => row.customer_name === selectedCustomer
// //         );
// //       }

// //       setRows(filteredRows);
// //       // const uniqueCustomers = [...new Set(response.map((item) => item.customer_name))];
// //       // setCustomers(uniqueCustomers);
// //     }
// //   } catch (error) {
// //     console.error('Error fetching data:', error);
// //     setRows([]);
// //     setCustomers([]);
// //   }
// // };

// //   const handleChangePage = (event, newPage) => {
// //     setController((prev) => ({ ...prev, page: newPage }));
// //   };

// //   const handleChangeRowsPerPage = (event) => {
// //     setController({
// //       page: 0,
// //       rowsPerPage: parseInt(event.target.value, 10),
// //     });
// //   };

// //   // const handleSearch = (e) => {
// //   //   setSearchKey(e.target.value);
// //   //   setController((prev) => ({ ...prev, page: 0 }));
// //   // };
// //   const handleSearch = (e) => {
// //   const val = e.target.value.toLowerCase();
// //   setSearchKey(e.target.value);
// //   setController((prev) => ({ ...prev, page: 0 }));
// //   if (val === '') {
// //     setSelectedCustomer('');
// //   } else {
// //     const matched = customers.find(c => c.name.toLowerCase().includes(val));
// //     if (matched) setSelectedCustomer(matched.name);
// //   }
// // };

// //   const handleCustomerChange = (event) => {
// //     setSelectedCustomer(event.target.value);
// //     setController((prev) => ({ ...prev, page: 0 }));
// //   };

// //   const handleOpenDialog = (row) => {
// //     setDialogData(row.cylinders || []);
// //     setDialogTitle(`Cylinder Details for ${row.customer_name} (${row.product_code}) - ${formattedDate}`);
// //     setOpenDetail(true);
// //   };

// //   const handleClose = () => {
// //     setOpenDetail(false);
// //     setDialogData([]);
// //     setDialogTitle('');
// //   };

// //   // const dateConversion = (date) => {
// //   //   if (!date) return '';
// //   //   const today = new Date(date);
// //   //   const dd = String(today.getDate()).padStart(2, '0');
// //   //   const mm = String(today.getMonth() + 1).padStart(2, '0');
// //   //   const yyyy = today.getFullYear();
// //   //   return `${dd}/${mm}/${yyyy}`;
// //   // };

// //   const dateConversion = (date) => {
// //   if (!date || date === '-') return '-';
// //   const d = new Date(date);
// //   if (isNaN(d.getTime())) return '-';  // ← add karo
// //   const dd = String(d.getDate()).padStart(2, '0');
// //   const mm = String(d.getMonth() + 1).padStart(2, '0');
// //   const yyyy = d.getFullYear();
// //   return `${dd}/${mm}/${yyyy}`;
// // };

// //   const handlePrint = (isDialog = false, dialogTitle = '') => {
// //     const printContentId = isDialog ? 'printable-dialog-table' : 'printable-main-table';
// //     const printContent = document.getElementById(printContentId)?.outerHTML || '';

// //     if (!printContent) {
// //       setSuccessMessage('Error: No content available to print');
// //       return;
// //     }

// //     const printWindow = window.open('', '_blank');
// //     if (!printWindow) {
// //       setSuccessMessage('Error: Unable to open print window. Please check pop-up blocker settings.');
// //       return;
// //     }

// //     const tableStyles = `
// //       <style>
// //         body { 
// //           font-family: Arial, sans-serif; 
// //           margin: 20px; 
// //         }
// //         table { 
// //           width: 100%; 
// //           border-collapse: collapse; 
// //         }
// //         th, td { 
// //           border: 1px solid #ddd; 
// //           padding: 8px; 
// //           text-align: left; 
// //           font-size: 14px; 
// //         }
// //         th { 
// //           background-color: #f2f2f2; 
// //           font-weight: bold; 
// //         }
// //         tr:nth-child(even) { 
// //           background-color: #f9f9f9; 
// //         }
// //         .inspection_cell:hover { 
// //           background-color: #f5f5f5; 
// //           cursor: pointer; 
// //         }
// //         @media print { 
// //           .no-print { display: none; } 
// //         }
// //       </style>
// //     `;

// //     printWindow.document.write(`
// //       <html>
// //         <head>
// //           <title>Customer Holding Report${isDialog ? ' - Cylinder Details' : ''}</title>
// //           ${tableStyles}
// //         </head>
// //         <body>
// //           <h3>${isDialog ? dialogTitle : 'Customer Holding Report'}</h3
// //           >
// //           ${printContent}
// //         </body>
// //       </html>
// //     `);

// //     printWindow.document.close();
// //     printWindow.onload = () => {
// //       printWindow.focus();
// //       printWindow.print();
// //       printWindow.onafterprint = () => printWindow.close();
// //       setTimeout(() => printWindow.close(), 0);
// //     };
// //   };

// //   const start = controller.page * controller.rowsPerPage;
// //   const end = start + controller.rowsPerPage;
// //   const paginatedRows = rows.slice(start, end);
// //   const paginationInfo = `${start + 1}-${Math.min(end, rows.length)} of ${rows.length}`;

// //   return (
// //     <Box className={styles.cts_page} sx={{ padding: '0px', margin: '0px' }}>
// //       <Box className={styles.body}>
// //         <Breadcrumb routeSegments={[{ name: 'Customer Holding Report' }]} />

// //         {/* <HeaderSection
// //           title="CUSTOMER HOLDING REPORT"
// //           searchKey={searchKey}
// //           handleSearch={handleSearch}
// //           sortedRows={rows}
// //           fields={[]}
// //           labels={[]}
// //           filename="Customer_Holding_Report"
// //           paginationInfo={paginationInfo}
// //           controller={controller}
// //           handleChangePage={handleChangePage}
// //           showAddButton={false}
// //         /> */}

// // <Typography className={styles.header_txt}>CUSTOMER HOLDING REPORT</Typography>
// //         {/* <Box sx={{ mb: 2, ml: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
// //           <FormControl sx={{ minWidth: 200 }}>
// //             <Select
// //               value={selectedCustomer}
// //               onChange={handleCustomerChange}
// //               displayEmpty
// //             >
// //             <MenuItem value="">All Customers</MenuItem>
// // {customers.map((c, idx) => (
// //   <MenuItem key={idx} value={c.name}>{c.name}</MenuItem>
// // ))}
// //             </Select>
// //           </FormControl>
// //           <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
// //             <Button
// //               variant="contained"
// //               startIcon={<PrintIcon />}
// //               onClick={() => handlePrint(false)}
// //               className="no-print"
// //             >
// //               Print
// //             </Button>
// //           </Box>
// //         </Box> */}

// //         <Box sx={{ mb: 2, ml: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
// //   <Autocomplete
// //   sx={{ width: 400 }}
// //   // options={customers.map(c => c.name)}
// //   // value={selectedCustomer || null}
// //   // onChange={(event, newValue) => {
// //   //   setSelectedCustomer(newValue || '');
// //   //   setController(prev => ({ ...prev, page: 0 }));
// //   // }}
// //   options={['All Customers', ...customers.map(c => c.name)]}
// // value={selectedCustomer || null}
// // placeholder="All Customers"
// // onChange={(event, newValue) => {
// //   setSelectedCustomer(newValue === 'All Customers' ? '' : (newValue || ''));
// //   setController(prev => ({ ...prev, page: 0 }));
// // }}
// //   // renderInput={(params) => (
// //   //   <TextField {...params} placeholder="Search customer..." size="small" />
// //   // )}
// // // filterOptions={(options, { inputValue }) =>
// // //   inputValue
// // //     ? options.filter(o =>
// // //         o !== 'All Customers' && o.toLowerCase().startsWith(inputValue.toLowerCase())
// // //       )
// // //     : options
// // // }
// // filterOptions={(options, { inputValue }) => {
// //   if (!inputValue) return options;
// //   const val = inputValue.toLowerCase();
// //   const matched = options.filter(o =>
// //     o !== 'All Customers' && o.toLowerCase().includes(val)
// //   );
// //   matched.sort((a, b) => {
// //     const aStarts = a.toLowerCase().startsWith(val);
// //     const bStarts = b.toLowerCase().startsWith(val);
// //     if (aStarts && !bStarts) return -1;
// //     if (!aStarts && bStarts) return 1;
// //     return 0;
// //   });
// //   return ['All Customers', ...matched];
// // }}
// // renderInput={(params) => (
// //   <TextField {...params} placeholder="All Customers" size="small" />
// // )}
// // />

// //   {/* Show button */}
// //   <Button
// //     variant="contained"
// //     onClick={fetchData}
// //     className="no-print"
// //   >
// //     Show
// //   </Button>

// //   <Button
// //     variant="outlined"
// //     startIcon={<PrintIcon />}
// //     onClick={() => handlePrint(false)}
// //     className="no-print"
// //   >
// //     Print
// //   </Button>
// // </Box>

// //         <Paper sx={{ width: '100%' }}>
// //           <TableContainer component={Paper} className={styles.list_tbl_container} id="printable-main-table">
// //             <Table size="small" stickyHeader>
// //               <TableHead>
// //                 <StyledTableRow>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     Sr No
// //                   </StyledTableCell>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     Customer Name
// //                   </StyledTableCell>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     Product Code
// //                   </StyledTableCell>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     Total No Of Cylinder
// //                   </StyledTableCell>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     TGPL Cylinders
// //                   </StyledTableCell>
// //                   <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>
// //                     Customer Cylinders
// //                   </StyledTableCell>
// //                 </StyledTableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {paginatedRows.length > 0 ? (
// //                   paginatedRows.map((row, index) => (
// //                     <StyledTableRow key={index}>
// //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// //                         {index + 1}
// //                       </StyledTableCell>
// //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// //                         {row.customer_name}
// //                       </StyledTableCell>
// //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// //                         {row.product_code}
// //                       </StyledTableCell>
// //                       <StyledTableCell
// //                         align="left"
// //                         className={styles.inspection_cell}
// //                         onClick={() => handleOpenDialog(row)}
// //                         style={{ cursor: 'pointer', color: '#1976d2' }}
// //                       >
// //                         {row.total_cylinders}
// //                       </StyledTableCell>
// //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// //                         {row.tgpl_cylinders ?? 0}
// //                       </StyledTableCell>
// //                       <StyledTableCell align="left" className={styles.inspection_cell}>
// //                         {row.customer_cylinders ?? 0}
// //                       </StyledTableCell>
// //                     </StyledTableRow>
// //                   ))
// //                 ) : (
// //                   <StyledTableRow>
// //                     <StyledTableCell colSpan={6} align="center">
// //                       0 Cylinders
// //                     </StyledTableCell>
// //                   </StyledTableRow>
// //                 )}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>

// //           <TablePagination
// //             component="div"
// //             count={rows.length}
// //             page={controller.page}
// //             onPageChange={handleChangePage}
// //             rowsPerPage={controller.rowsPerPage}
// //             onRowsPerPageChange={handleChangeRowsPerPage}
// //             className="no-print"
// //           />
// //         </Paper>

// //         <Dialog
// //           PaperProps={{
// //             sx: {
// //               minWidth: '90%',
// //               maxHeight: '90%',
// //             },
// //           }}
// //           onClose={handleClose}
// //           open={openDetail}
// //         >
// //           <DialogTitle id="customized-dialog-title">
// //             {dialogTitle}
// //             <IconButton
// //               aria-label="close"
// //               onClick={handleClose}
// //               sx={{
// //                 position: 'absolute',
// //                 right: 8,
// //                 top: 8,
// //               }}
// //             >
// //               <CloseIcon />
// //             </IconButton>
// //           </DialogTitle>
// //           <DialogContent dividers>
// //             <Box sx={{ display: 'flex', justifyContent: 'flex-end' ,paddingBottom:'20px' }}>
// //               <Button
// //                 variant="contained"
// //                 startIcon={<PrintIcon />}
// //                 onClick={() => handlePrint(true, dialogTitle)}
// //                 className="no-print"
// //               >
// //                 Print
// //               </Button>
// //             </Box>
// //             <TableContainer
// //               component={Paper}
// //               className={`${styles.list_tbl_container} printable-table`}
// //               id="printable-dialog-table"
// //             >
// //               <Table size="small" stickyHeader className="printable-table">
// //                 <TableHead className={styles.table_head_container}>
// //                   <StyledTableRow>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Sr No</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Cylinder No</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Tag No</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>Owner</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>DC_NO</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important',paddingLeft:'5px' }}>DC_Date</StyledTableCell>
// //                     <StyledTableCell sx={{ textAlign: 'left !important', paddingLeft: '5px' }}>Days</StyledTableCell>
// //                   </StyledTableRow>
// //                 </TableHead>
// //                 <TableBody sx={{ backgroundColor: '#fff' }}>
// //                   {dialogData.length > 0 ? (
// //                     dialogData.map((row, index) => (
// //                       <StyledTableRow key={index}>
// //                         <StyledTableCell align="left">{index + 1}</StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //                           {row.cylinder_no || '-'}
// //                         </StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //                           {row.tag_no || '-'}
// //                         </StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //                           {row.owner || '-'}
// //                         </StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //                           {row.dc_no || '-'}
// //                         </StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //                           {dateConversion(row.dc_date || '-')}
// //                         </StyledTableCell>
// //                         <StyledTableCell align="left" className={styles.inspection_cell}>
// //   {row.dc_date && row.dc_date !== '-'
// //     ? Math.floor((new Date() - new Date(row.dc_date)) / (1000 * 60 * 60 * 24))
// //     : '-'}
// // </StyledTableCell>
// //                       </StyledTableRow>
// //                     ))
// //                   ) : (
// //                     <StyledTableRow>
// //                       <StyledTableCell colSpan={4} align="center">
// //                         No cylinder details available
// //                       </StyledTableCell>
// //                     </StyledTableRow>
// //                   )}
// //                 </TableBody>
// //               </Table>
// //             </TableContainer>
// //           </DialogContent>
// //         </Dialog>

// //         <ReusableSnackbar
// //           open={!!successMessage}
// //           onClose={(event, reason) => {
// //             if (reason !== 'clickaway') {
// //               setSuccessMessage(null);
// //             }
// //           }}
// //           message={successMessage}
// //           autoHideDuration={2000}
// //           vertical="top"
// //           horizontal="right"
// //         />
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default CustomerHoldingReport;



// import React, { useEffect, useState } from "react";
// import {
//   Box, Typography, TextField, MenuItem, Button, Table,
//   TableHead, TableBody, TableRow, TableCell, TableContainer, Paper,Autocomplete 
// } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import axios from "axios";

// const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px", height: "38px", background: "#fafafa",
//     "& fieldset": { borderColor: "#E2E8F0" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0" },
//   },
// };



// const thSx = {
//   background: "#1C3A5E", color: "#fff", fontSize: "12px",
//   fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap"
// };

// const tdSx = { fontSize: "12px", padding: "8px 12px", color: "#2D3748" };

// const CustomerHoldingReport = () => {
//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState("");
//  const [fromDate, setFromDate] = useState(dayjs());
//   const [toDate, setToDate] = useState(dayjs());
//   const [reportData, setReportData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     axios.get(`${API}/api/cust-ledger/customers`)
//       .then(res => setCustomers(res.data))
//       .catch(err => console.error(err));
//   }, []);

//   const fetchReport = async () => {
//     if (!selectedCustomer) return;
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API}/api/cust-ledger/report`, {
//         params: {
//           customer_id: selectedCustomer,
//           from_date: fromDate.format("YYYY-MM-DD"),
//           to_date: toDate.format("YYYY-MM-DD"),
//         }
//       });
//       setReportData(res.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ background: "#F4F7FB", minHeight: "100vh", padding: "20px 24px 40px" }}>

//         {/* Header */}
//         <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1C3A5E", mb: 2.5 }}>
//           Cylinder Holding Report
//         </Typography>

//         {/* Filters */}
//         <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", p: 2.5, mb: 2.5, display: "flex", gap: 2, alignItems: "flex-end", flexWrap: "wrap" }}>

//           {/* Customer Dropdown */}
//          <Box sx={{ minWidth: 250 }}>
//   <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
//     Name of Customer
//   </Typography>
//   <Autocomplete
//     options={customers}
//     getOptionLabel={o => o.cust_name || ""}
//     value={customers.find(c => c.cust_id === selectedCustomer) || null}
//     onChange={(e, nv) => { setSelectedCustomer(nv ? nv.cust_id : ""); setReportData(null); }}
//     isOptionEqualToValue={(o, v) => o.cust_id === v.cust_id}
//     renderInput={params => (
//       <TextField {...params} size="small" placeholder="Type or select customer" sx={inputSx} />
//     )}
//     sx={{ minWidth: 250 }}
//   />
// </Box>

//           {/* From Date */}
//           <Box>
//             <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>From Date</Typography>
//             <DatePicker
//               format="DD/MM/YYYY" value={fromDate}
//               onChange={v => setFromDate(v)}
//               slotProps={{ textField: { size: "small", sx: inputSx } }}
//             />
//           </Box>

//           {/* To Date */}
//           <Box>
//             <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>To Date</Typography>
//             <DatePicker
//               format="DD/MM/YYYY" value={toDate}
//               onChange={v => setToDate(v)}
//               slotProps={{ textField: { size: "small", sx: inputSx } }}
//             />
//           </Box>

//           {/* Search Button */}
//           <Button
//             onClick={fetchReport} disabled={!selectedCustomer || loading}
//             sx={{  height: "38px", px: 3, background: "#1C3A5E", 
//   color: "#fff !important",  // !important add karo
//   borderRadius: "8px", fontSize: "13px", fontWeight: 600, 
//   textTransform: "none", 
//   "&:hover": { background: "#2B6CB0" }  }}
//           >
//             {loading ? "Loading..." : "Search"}
//           </Button>
//         </Box>

//         {/* Report */}
//         {reportData && (
//           <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//             {/* Customer Info */}
//             {/* <Box sx={{ background: "#1C3A5E", p: "9px 22px" }}>
//               <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff" }}>
//                 CYLINDER HOLDING REPORT
//               </Typography>
//             </Box> */}

//             <Box sx={{ p: 2.5, borderBottom: "1px solid #E2E8F0", display: "flex", gap: 4, flexWrap: "wrap" }}>
//               {/* <Box>
//                 <Typography sx={{ fontSize: "11px", color: "#718096" }}>Name of Customer</Typography>
//                 <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>{reportData.customer.cust_name}</Typography>
//               </Box>
//               <Box>
//                 <Typography sx={{ fontSize: "11px", color: "#718096" }}>Address</Typography>
//                 <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>
//                   {[reportData.customer.cust_address, reportData.customer.city, reportData.customer.state].filter(Boolean).join(", ")}
//                 </Typography>
//               </Box>
//               <Box>
//                 <Typography sx={{ fontSize: "11px", color: "#718096" }}>From Date</Typography>
//                 <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>{fromDate.format("DD/MM/YYYY")}</Typography>
//               </Box>
//               <Box>
//                 <Typography sx={{ fontSize: "11px", color: "#718096" }}>To Date</Typography>
//                 <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>{toDate.format("DD/MM/YYYY")}</Typography>
//               </Box> */}
//               <Box>
//                 <Typography sx={{ fontSize: "11px", color: "#718096" }}>Opening Balance</Typography>
//                 <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#2F855A" }}>{reportData.opening_balance}</Typography>
//               </Box>
//             </Box>

//             {/* Table */}
//             <TableContainer>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     {["Sr No", "Date", "DC Number", "Full Cylinder Delivered", "ECR No", "Empty Collection", "Closing Balance"].map(h => (
//                       <TableCell key={h} sx={thSx}>{h}</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {reportData.transactions.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={7} sx={{ textAlign: "center", color: "#A0AEC0", py: 4, fontSize: "13px" }}>
//                         No records found
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     reportData.transactions.map((row, idx) => (
//                       <TableRow key={row.id} sx={{ background: idx % 2 === 0 ? "#fff" : "#F8FAFC" }}>
//                         <TableCell sx={tdSx}>{idx + 1}</TableCell>
//                         <TableCell sx={tdSx}>{dayjs(row.date).format("DD/MM/YYYY")}</TableCell>
//                         <TableCell sx={tdSx}>{row.delivered > 0 ? row.challan_no : "—"}</TableCell>
//                         <TableCell sx={{ ...tdSx, color: "#2F855A", fontWeight: 600 }}>{row.delivered || "—"}</TableCell>
//                         <TableCell sx={tdSx}>{row.collected > 0 ? row.challan_no : "—"}</TableCell>
//                         <TableCell sx={{ ...tdSx, color: "#E53E3E", fontWeight: 600 }}>{row.collected || "—"}</TableCell>
//                         <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.closing_bal}</TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Footer - Closing Balance */}
//         {/* Footer */}
// {reportData.transactions.length > 0 && (() => {
//   const totalDelivered = reportData.transactions.reduce((sum, r) => sum + (parseFloat(r.delivered) || 0), 0);
//   const finalClosing = parseFloat(reportData.transactions[reportData.transactions.length - 1].closing_bal) || 0;
//   const ctr = finalClosing > 0 ? (totalDelivered / finalClosing).toFixed(2) : "N/A";

//   return (
//     <Box sx={{ p: 2, borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end", gap: 4 }}>
//       <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
//         Final Closing Balance: <span style={{ color: "#2F855A" }}>{finalClosing}</span>
//       </Typography>
//       <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
//         Current CTR: <span style={{ color: "#2B6CB0" }}>{ctr}</span>
//       </Typography>
//     </Box>
//   );
// })()}
//           </Box>
//         )}
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default CustomerHoldingReport;

import React, { useEffect, useState } from "react";
import {
  Box, Typography, TextField, Button, Table,RadioGroup,Radio,FormControlLabel,
  TableHead, TableBody, TableRow, TableCell, TableContainer, Autocomplete
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import axios from "axios";
import axiosClient from "../../../configs/axios";
import depotMasterService from "../../../services/masters/depotMaster.Service";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const printStyles = `
  .ctr-print-header { display: none; }
  @media print {
    .ctr-print-header { display: block !important; margin-bottom: 16px; }
    body * { visibility: hidden; }
    .ctr-printable-area, .ctr-printable-area * { visibility: visible; }
    .ctr-printable-area {
      position: absolute; left: 0; top: 0;
      width: 100%; overflow: visible !important;
      height: auto !important; max-height: none !important;
    }
    .ctr-printable-area table { border-collapse: collapse; width: 100%; }
    .ctr-printable-area th, .ctr-printable-area td { border: 1px solid #ccc; padding: 6px 10px; font-size: 12px; }
    .ctr-printable-area th { background: #1C3A5E !important; color: #fff !important; -webkit-print-color-adjust: exact; }
    .no-print { display: none !important; }
  }
`;

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px", height: "38px", background: "#fafafa",
    "& fieldset": { borderColor: "#E2E8F0" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0" },
  },
  "& .MuiSelect-select": { color: "#1A202C" },
  "& .MuiInputBase-input": { color: "#1A202C" },
};

const toggleBtnSx = (active) => ({
  height: "38px",
  px: 2.5,
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  border: active ? "1.5px solid #1C3A5E" : "1.5px solid #E2E8F0",
  background: active ? "#1C3A5E" : "#fff",
  color: active ? "#fff !important" : "#4A5568 !important",
  "&:hover": { background: active ? "#2B6CB0" : "#F0F4F8" },
});

const thSx = {
  background: "#1C3A5E", color: "#fff", fontSize: "12px",
  fontWeight: 600, padding: "10px 12px", whiteSpace: "nowrap"
};

const tdSx = { fontSize: "12px", padding: "8px 12px", color: "#2D3748" };

const CustomerHoldingReport = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState("customer"); // "customer" | "depot"
const [depots, setDepots] = useState([]);
const [selectedDepot, setSelectedDepot] = useState("");

  // Inject print styles
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);


  useEffect(() => {
  depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" })
    .then(res => {
      const list = Array.isArray(res) ? res : (res?.data || []);
      setDepots(list);
    })
    .catch(err => console.error("Depot fetch failed:", err));
}, []);

  // Fetch customer list
  // Fetch customer list
  useEffect(() => {
    axiosClient.get(`/cust-ledger/customers`)
      .then(res => setCustomers(res.data))
      .catch(err => console.error(err));
  }, []);

 const fetchReport = async () => {
  if (reportType === "customer" && !selectedCustomer) return;
  if (reportType === "depot" && !selectedDepot) return;

  setLoading(true);
  try {
const endpoint = reportType === "customer"
  ? `/cust-ledger/report`
  : `/cust-ledger/depot-report`;   // ⚠️ apne actual depot-report endpoint se replace karo

const params = reportType === "customer"
  ? {
      customer_id: selectedCustomer,
      from_date: fromDate.format("YYYY-MM-DD"),
      to_date: toDate.format("YYYY-MM-DD"),
    }
  : {
      depot_id: selectedDepot,
      from_date: fromDate.format("YYYY-MM-DD"),
      to_date: toDate.format("YYYY-MM-DD"),
    };

 const res = await axiosClient.get(endpoint, { params });
    setReportData(res.data);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const handlePrint = () => { window.print(); };

  // CTR calculation
  const getCTRData = () => {
    if (!reportData || !reportData.transactions.length) return { totalDelivered: 0, finalClosing: 0, ctr: "N/A" };
    const totalDelivered = reportData.transactions.reduce((sum, r) => sum + (parseFloat(r.delivered) || 0), 0);
    const finalClosing = parseFloat(reportData.transactions[reportData.transactions.length - 1].closing_bal) || 0;
const ctr = finalClosing !== 0 ? (totalDelivered / Math.abs(finalClosing)).toFixed(2) : "N/A";
    return { totalDelivered, finalClosing, ctr };
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ background: "#F4F7FB", minHeight: "100vh", padding: "20px 24px 40px" }}>

        {/* Header */}
        <Typography className="no-print" sx={{ fontSize: "16px", fontWeight: 700, color: "#1C3A5E", mb: 2.5 }}>
          Cylinder Ledger
        </Typography>

        {/* ── Filter Card ── */}
        <Box className="no-print" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", p: 2.5, mb: 2.5 }}>

          {/* Row 1 - Filters */}
          {/* Row 1 - Filters */}
<Box sx={{ display: "flex", gap: 2, alignItems: { xs: "stretch", sm: "flex-end" }, flexWrap: "wrap", flexDirection: { xs: "column", sm: "row" } }}>

  {/* ✅ NEW: Report Type Toggle */}
  {/* ✅ Report Type Radio */}
<Box sx={{ width: { xs: "100%", sm: "auto" } }}>
  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
    Report Type
  </Typography>
  <RadioGroup
    row
    value={reportType}
    onChange={(e) => {
      const val = e.target.value;
      setReportType(val);
      setReportData(null);
      if (val === "customer") setSelectedDepot("");
      else setSelectedCustomer("");
    }}
  >
    <FormControlLabel
      value="customer"
      control={<Radio size="small" sx={{ color: "#2B6CB0", "&.Mui-checked": { color: "#1C3A5E" } }} />}
      label={<Typography sx={{ fontSize: "13px" }}>Customer Wise</Typography>}
    />
    {/* <FormControlLabel
      value="depot"
      control={<Radio size="small" sx={{ color: "#2B6CB0", "&.Mui-checked": { color: "#1C3A5E" } }} />}
      label={<Typography sx={{ fontSize: "13px" }}>Depot Wise</Typography>}
    /> */}
  </RadioGroup>
</Box>

  {/* Customer OR Depot Autocomplete (conditional) */}
  {reportType === "customer" ? (
   <Box sx={{ width: { xs: "100%", sm: 250 } }}>
  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
        Name of Customer
      </Typography>
      <Autocomplete
  options={[{ cust_id: "all", cust_name: "" }, ...customers]}
  getOptionLabel={o => o.cust_name || ""}
  value={
    selectedCustomer === "all"
      ? { cust_id: "all", cust_name: "" }
      : customers.find(c => c.cust_id === selectedCustomer) || null
  }
  onChange={(e, nv) => { setSelectedCustomer(nv ? nv.cust_id : ""); setReportData(null); }}
  isOptionEqualToValue={(o, v) => o.cust_id === v.cust_id}
  renderOption={(props, option) => (
    <li {...props} style={option.cust_id === "all" ? { fontWeight: 700, color: "#1C3A5E", borderBottom: "1px solid #E2E8F0" } : {}}>
      {option.cust_name}
    </li>
  )}
  renderInput={params => (
    <TextField {...params} size="small" placeholder="Type or select customer" sx={inputSx} />
  )}
 sx={{ width: "100%" }}
/>
    </Box>
  ) : (
    <Box sx={{ width: { xs: "100%", sm: 250 } }}>
  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>
    Name of Depot
  </Typography>
 <Autocomplete
  options={[{ depot_id: "all", depot_name: "All Depots" }, ...depots]}
  getOptionLabel={o => o.depot_name || ""}
  value={
    selectedDepot === "all"
      ? { depot_id: "all", depot_name: "All Depots" }
      : depots.find(d => d.depot_id === selectedDepot) || null
  }
  onChange={(e, nv) => { setSelectedDepot(nv ? nv.depot_id : ""); setReportData(null); }}
  isOptionEqualToValue={(o, v) => o.depot_id === v.depot_id}
  renderOption={(props, option) => (
    <li {...props} style={option.depot_id === "all" ? { fontWeight: 700, color: "#1C3A5E", borderBottom: "1px solid #E2E8F0" } : {}}>
      {option.depot_name}
    </li>
  )}
  renderInput={params => (
    <TextField {...params} size="small" placeholder="Type or select depot" sx={inputSx} />
  )}
 sx={{ width: "100%" }}
/>
</Box>
  )}

  

            {/* From Date */}
          <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>From Date</Typography>
              <DatePicker
                format="DD/MM/YYYY" value={fromDate}
                onChange={v => setFromDate(v)}
           slotProps={{ textField: { size: "small", fullWidth: true, sx: inputSx } }}
              />
            </Box>

            {/* To Date */}
            <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#2063b6", mb: "4px" }}>To Date</Typography>
              <DatePicker
                format="DD/MM/YYYY" value={toDate}
                onChange={v => setToDate(v)}
                slotProps={{ textField: { size: "small", sx: inputSx } }}
              />
            </Box>

            {/* Search */}
          <Button
  onClick={fetchReport} 
  disabled={(reportType === "customer" ? !selectedCustomer : !selectedDepot) || loading}
  sx={{ height: "38px", px: 3, width: { xs: "100%", sm: "auto" }, background: "#1C3A5E", color: "#fff !important", borderRadius: "8px", fontSize: "13px", fontWeight: 600, textTransform: "none", "&:hover": { background: "#2B6CB0" } }}
>
              {loading ? "Loading..." : "Show"}
            </Button>
          </Box>

          {/* Row 2 - Customer info + Print (after search) */}
          {reportData && (
            <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 2 }}>
              <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                {/* <Box>
                  <Typography sx={{ fontSize: "11px", color: "#718096" }}>Address</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>
                    {[reportData.customer.cust_address, reportData.customer.city, reportData.customer.state].filter(Boolean).join(", ") || "—"}
                  </Typography>
                </Box> */}
                {/* <Box>
                  <Typography sx={{ fontSize: "11px", color: "#718096" }}>From Date</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>{fromDate.format("DD/MM/YYYY")}</Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "11px", color: "#718096" }}>To Date</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1C3A5E" }}>{toDate.format("DD/MM/YYYY")}</Typography>
                </Box> */}
                <Box>
                <Typography sx={{ fontSize: "15px" }}><strong>Opening Balance:</strong> {reportData.opening_balance}</Typography>
                  {/* <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#2F855A" }}>{reportData.opening_balance}</Typography> */}
                </Box>
              </Box>

              {/* Print Button */}
              <Button
                onClick={handlePrint}
                sx={{ height: "38px", px: 3, background: "#2B6CB0", color: "#fff !important", borderRadius: "8px", fontSize: "13px", fontWeight: 600, textTransform: "none", "&:hover": { background: "#1C3A5E" } }}
              >
                🖨️ Print
              </Button>
            </Box>
          )}
        </Box>

        {/* ── Report Table ── */}
        {reportData && (
          <Box className="ctr-printable-area" sx={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

            {/* Print-only header */}
            <Box className="ctr-print-header">
              <Typography sx={{ fontSize: "18px", fontWeight: 700, textAlign: "center", color: "#1C3A5E", mb: 1 }}>
                CYLINDER Ledger
              </Typography>
              <Typography sx={{ fontSize: "13px" }}>
  <strong>{reportType === "customer" ? "Name of Customer" : "Name of Depot"}:</strong>{" "}
  {reportType === "customer"
    ? reportData.customer?.cust_name
    : reportData.depot?.depot_name}
</Typography>
<Typography sx={{ fontSize: "13px" }}>
  <strong>Address:</strong>{" "}
  {reportType === "customer"
    ? [reportData.customer?.cust_address, reportData.customer?.city, reportData.customer?.state].filter(Boolean).join(", ") || "—"
    : reportData.depot?.depot_address || "—"}
</Typography>
              <Typography sx={{ fontSize: "13px" }}>
                <strong>From Date:</strong> {fromDate.format("DD/MM/YYYY")} &nbsp;&nbsp;
                <strong>To Date:</strong> {toDate.format("DD/MM/YYYY")}
              </Typography>
              <hr style={{ border: "none", borderTop: "1.5px solid #1C3A5E", margin: "8px 0" }} />
              <Typography sx={{ fontSize: "15px" }}><strong>Opening Balance:</strong> {reportData.opening_balance}</Typography>
            </Box>

            {/* Table */}
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {["Sr No", "Date", "DC Number", "Full Cylinder Delivered", "ECR No", "Empty Collection", "Closing Balance"].map(h => (
                      <TableCell key={h} sx={thSx}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.transactions.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ textAlign: "center", color: "#A0AEC0", py: 4, fontSize: "13px" }}>
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    reportData.transactions.map((row, idx) => (
                      <TableRow key={row.id} sx={{ background: idx % 2 === 0 ? "#fff" : "#F8FAFC" }}>
                        <TableCell sx={tdSx}>{idx + 1}</TableCell>
                        <TableCell sx={tdSx}>{dayjs(row.date).format("DD/MM/YYYY")}</TableCell>
                        <TableCell sx={tdSx}>{row.delivered > 0 ? row.challan_no : "—"}</TableCell>
                        <TableCell sx={{ ...tdSx, color: "#2F855A", fontWeight: 600 }}>{row.delivered || "—"}</TableCell>
                        <TableCell sx={tdSx}>{row.collected > 0 ? row.challan_no : "—"}</TableCell>
                        <TableCell sx={{ ...tdSx, color: "#E53E3E", fontWeight: 600 }}>{row.collected || "—"}</TableCell>
                        <TableCell sx={{ ...tdSx, fontWeight: 700 }}>{row.closing_bal}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Footer - CTR left, Closing Balance right */}
            {reportData.transactions.length > 0 && (() => {
              const { finalClosing, ctr } = getCTRData();
              return (
                <Box sx={{ p: 2, borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
                    Current CTR: <span style={{ color: "#2B6CB0" }}>{ctr}</span>
                  </Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1C3A5E" }}>
                    Final Closing Balance: <span style={{ color: "#2F855A" }}>{finalClosing}</span>
                  </Typography>
                </Box>
              );
            })()}
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default CustomerHoldingReport;